var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "146px",
    height: "146px",
    viewBox: "0 0 146 146",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-427.000000, -349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(427.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D1E3FA",
    cx: 73,
    cy: 72.9999629,
    rx: 73,
    ry: 72.9999629
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.392539, 21.193538)",
    fill: "#1A73E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.188784,95.3115773 C103.384425,76.8301399 81.671411,65.9426693 58.6035948,65.9354346 C35.5357786,65.9282071 13.8159429,76.8020626 0,95.2748419 C13.7474404,113.843678 35.4811564,124.799216 58.5851403,124.806462 C81.6891243,124.813701 103.429705,113.871791 117.188784,95.3115773 L117.188784,95.3115773 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 58.6074613,
    cy: 28.2580501,
    rx: 28.2580645,
    ry: 28.2580501
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.d4c47e307376077f8a91081fb9814269.svg";
export { ForwardRef as ReactComponent };